module.exports = __webpack_public_path__ + "static/media/settings_darkmode_white.1d568402.svg";